module.exports = __webpack_public_path__ + "img/menu-mobile-close.055acc19.svg";